<template>
  <div class="p-12 pr-6 all">
    <div class="flex items-center">
      <div class="w-1/2 flex text-left text-c42 items-center font-c8 mb-5">
        Programmes
      </div>

      <div class="w-1/2 flex justify-end">
        <buton
          label="Nouveau programme"
          class="w-2/5"
          size="18px"
          rounded="6px"
          weight="500"
          background="#312879"
          @click="showAddProgram = true"
        />
      </div>
    </div>

    <globalData />

    <!-- Passer la prop "visible" -->
    <addPrograms 
      v-if="showAddProgram" 
      :visible="showAddProgram" 
      @close="showAddProgram = false" 
      @refresh="refresh"
    />
  </div>
</template>

<script>
import buton from '../../component/helper/add/button.vue'
import globalData from '../../component/cdevs/programs/globalData.vue'
import addPrograms from '../../component/cdevs/programs/addPrograms.vue';
import apiRoutes from '../../router/api-routes';
import http from '../../plugins/https'

export default {
  components: {
    buton,
    globalData,
    addPrograms
  },
  data() {
    return {
      showAddProgram: false,
      sfdList: []
    }
  },

  created() {
    this.getData()
  },
  
  methods:{
        async getData() {
          try {
            const response = await http.get(apiRoutes.baseURL + apiRoutes.allSfd)
            this.sfdList = response.data
          } catch (error) {
            console.error(error)
          }
        },

    refresh() {
      this.getData()
    },
  }
}
</script>
